import React, { useContext } from "react";
import "./notifications.css";
import { AuthContext } from "../../context/AuthContext";
import { getUser } from "../../Localstorage/localstorage";
import SocketNotificationBridge from "./SocketNotificationBridge";
import NotificationToastStack from "./NotificationToastStack";

/**
 * Subscribes to Socket.IO user rooms when authenticated and renders toast UI.
 * Lives under the same Router as the rest of the app so toasts can navigate.
 */
const NotificationLayer = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const user = isAuthenticated ? getUser() : null;
  const userId = user?.id ?? null;

  return (
    <>
      {userId ? <SocketNotificationBridge userId={userId} /> : null}
      <NotificationToastStack />
    </>
  );
};

export default NotificationLayer;
